import { useSelector } from 'react-redux';
import { Routes, Route, Link } from 'react-router-dom';
import c from 'classnames';
import { v4 as uuid } from 'uuid';

import { getTinyAccounts } from 'store/account';
import { getKits } from 'store/shared';

import { Button, PageContainer, ContainerSizes, Typography } from 'components';
import ResampleCard from 'components/ResampleCard/ResampleCard';
import KitActivationContainer from './KitActivationContainer';
import { MyFamily } from './MyFamily';
import { NoKitRegistered } from '../Results';
import { TinyAccountKits } from './TinyAccountKits/TinyAccountKits';

import styles from './KitsPage.module.scss';

export const KitsRoutes = () => {
  return (
    <Routes>
      <Route path='activate/:kitId' element={<KitActivationContainer />} />
      <Route path='' element={<KitsPage />} />
    </Routes>
  );
};

export const KitsPage = () => {
  const tinyAccounts = useSelector(getTinyAccounts);
  const kits = useSelector(getKits);
  return (
    <div className={c(styles.pageContainer, styles.paddingBottom)}>
      <div className='p-3'>
        <Typography variant='heading-xl' className='dark-grey-text'>
          Kits
        </Typography>
      </div>
      {tinyAccounts?.length ? <hr className={styles.hr} /> : null}
      <div className='p-3'>
        <MyFamily
          type='row'
          tinyAccounts={tinyAccounts}
          title='My Family'
          withProfile={true}
        />
      </div>
      {tinyAccounts?.length ? (
        <hr className={c(styles.hr, styles.inverted)} />
      ) : null}

      <PageContainer size={ContainerSizes.MD}>
        <>
          <div className='p-3'>
            {kits.length > 0 ? (
              <div className={styles.accountsContainer}>
                {tinyAccounts?.map(tinyAccount => (
                  <TinyAccountKits key={uuid()} tinyAccount={tinyAccount} />
                ))}
              </div>
            ) : (
              <div className='mt-4 text-center'>
                <NoKitRegistered withCTA={false} />
              </div>
            )}
            <div className='flex justify-content-center'>
              <ResampleCard />
            </div>
          </div>
          <div className={styles.fixedBottom}>
            <Link to='/activate'>
              <Button width='full'>Activate kit</Button>
            </Link>
          </div>
        </>
      </PageContainer>
    </div>
  );
};
